module.exports = __webpack_public_path__ + "img/P9-zh.032e92b2.png";